import { colors } from "../../common/styles";

export default {
    viewButton: {
        textTransform: "lowercase",
        ":hover": {
            textDecoration: "underline"
        }
    },
    circle: {
        height: 10,
        width: 10,
        backgroundColor: "#bbb",
        borderRadius: "50%",
        display: "inline-block"
    },
    hideFont: {
        fontSize: 0,
        "& svg": {
            color: "inherit"
        },
        "& .MuiBadge-root .MuiBadge-badge": {
            margin: "6px 0"
        }
    },
    primaryButton: {
        color: "primary.main"
    }
};
